// extracted by mini-css-extract-plugin
module.exports = {"datascitab":"VirtualRestaurants_datascitab__36QAQ"};